<script lang="ts">
  import {onMount} from 'svelte';
  import Drawer from '@/widgets/drawer/Drawer.svelte';
  import {stepViews} from './utils';
  import {step$, stepMetaData$, initStep, componentStatus$} from './streams';

  export let LG;
  export let step;

  let drawerTransitionEnd = false;

  /**
   * 接受自定义入金步骤
   */
  step && step$.next(step);

  $: stepView = (stepViews[$step$] || stepViews.mainMenu) as typeof stepViews.mainMenu;

  onMount(() => {
    componentStatus$.next('visible');
    return () => {
      componentStatus$.next('hidden');
    };
  });

  function handleTransitionEndEvent(event) {
    drawerTransitionEnd = true;
  }

  function handleBackClick() {
    const historySteps = $stepMetaData$;
    const steps = historySteps.steps || [];
    const stepLength = steps.length;
    if (stepLength > 1) {
      step$.next(steps[stepLength - 1 - 1]);
    }
  }
</script>

<style lang="scss">
  .content {
    width: 480px;
    max-width: 100%;
  }
  .drawer-back-box {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background: #eff2f7;
    pointer-events: none;
    opacity: 0;
    transition: opacity 300ms;
    &.visible {
      pointer-events: all;
      opacity: 1;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .back-icon {
    color: #a7abb3;
  }
</style>

<Drawer on:close on:transitionend={handleTransitionEndEvent} autoCloseDrawer>
  <div slot="header">
    <div class="drawer-back-box df aic jcc cp" class:visible={![initStep, step].includes($step$ || '')} on:click={handleBackClick}>
      <i class="back-icon iconfont f18">&#xe6d1;</i>
    </div>
  </div>

  <div class="content">
    <svelte:component this={stepView.component} {...stepView.meta} {drawerTransitionEnd} {LG} {...$$props} />
  </div>
</Drawer>
